import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, mergeProps as _mergeProps, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  id: "appComponent"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { style: {"display":"flex"} }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { style: {"flex":"1"} }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Log Out ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")
  const _component_extension_table_outlined = _resolveComponent("extension-table-outlined")
  const _component_a_menu_item = _resolveComponent("a-menu-item")
  const _component_a_menu = _resolveComponent("a-menu")
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")
  const _component_menu_unfold_outlined = _resolveComponent("menu-unfold-outlined")
  const _component_menu_fold_outlined = _resolveComponent("menu-fold-outlined")
  const _component_logout_outlined = _resolveComponent("logout-outlined")
  const _component_a_layout_header = _resolveComponent("a-layout-header")
  const _component_a_layout_content = _resolveComponent("a-layout-content")
  const _component_a_layout = _resolveComponent("a-layout")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.layout == "authentication")
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_router_view)
        ]))
      : _createCommentVNode("", true),
    (_ctx.layout == "application")
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_a_layout, {
            class: "ant-pro-leftmenu-layout",
            style: {"min-height":"100vh"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_layout_sider, _mergeProps(_ctx.$attrs, {
                collapsed: _ctx.collapsed,
                style: {
            overflow: 'hidden',
          }
              }), {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu, {
                    theme: "dark",
                    mode: "inline",
                    selectedKeys: _ctx.selectedKeys,
                    "onUpdate:selectedKeys": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedKeys = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, {
                        key: "1",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openLink("extension_table")))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_extension_table_outlined),
                          (!_ctx.collapsed)
                            ? (_openBlock(), _createBlock("span", _hoisted_3, "Extension Table"))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, {
                        key: "4",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openLink("import_tasks")))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_extension_table_outlined),
                          (!_ctx.collapsed)
                            ? (_openBlock(), _createBlock("span", _hoisted_4, "Import Tasks"))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, {
                        key: "5",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openLink("e_shop_status")))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_extension_table_outlined),
                          (!_ctx.collapsed)
                            ? (_openBlock(), _createBlock("span", _hoisted_5, "EShop Import"))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, {
                        key: "6",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openLink("health_check")))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_extension_table_outlined),
                          (!_ctx.collapsed)
                            ? (_openBlock(), _createBlock("span", _hoisted_6, "Health Check"))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, {
                        key: "7",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openLink("boxed_price_lock")))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_extension_table_outlined),
                          (!_ctx.collapsed)
                            ? (_openBlock(), _createBlock("span", _hoisted_7, "Boxed Price Lock"))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_menu_item, {
                        key: "8",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openLink("boxed_category_list")))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_extension_table_outlined),
                          (!_ctx.collapsed)
                            ? (_openBlock(), _createBlock("span", _hoisted_8, "Boxed Category List"))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["selectedKeys"])
                ]),
                _: 1
              }, 16, ["collapsed"]),
              _createVNode(_component_a_layout, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_layout_header, {
                    style: {"background":"white","padding":"0"},
                    id: "header-component"
                  }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_9, [
                        (_ctx.collapsed)
                          ? (_openBlock(), _createBlock(_component_menu_unfold_outlined, {
                              key: 0,
                              class: "trigger",
                              onClick: _cache[8] || (_cache[8] = () => (_ctx.collapsed = !_ctx.collapsed))
                            }))
                          : (_openBlock(), _createBlock(_component_menu_fold_outlined, {
                              key: 1,
                              class: "trigger",
                              onClick: _cache[9] || (_cache[9] = () => (_ctx.collapsed = !_ctx.collapsed))
                            })),
                        _hoisted_10,
                        _createVNode("span", {
                          class: "logout-btn",
                          style: {"margin-right":"24px","color":"red","cursor":"pointer"},
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.logout()))
                        }, [
                          _createVNode(_component_logout_outlined, { style: {"margin-right":"2.5px"} }),
                          _hoisted_11
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_layout_content, { style: {"margin":"0 16px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_view)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}